import React from 'react';
import styles from './styles.module.css';
import Modal from 'react-modal';

const AlertError = ({open, onClose,message}) => {
    return (
        <Modal
            isOpen={open}
            ariaHideApp={false}
            className="rounded-lg w-[270px] absolute overflow-hidden top-1/2 left-1/2 bg-white -translate-y-2/4 -translate-x-2/4"
            contentLabel="Example Modal"
            overlayClassName="bg-black/50 w-full h-full fixed top-0 z-[1000]"
        >
            <div className="">
               <div className="p-4">
                   <h2 className="text-center font-bold text-base text-red-500 mb-2">Thông báo</h2>
                   <div className="text-sm text-center px-4">
                       {message}
                   </div>
               </div>
                <div className="p-2 bg-zinc-100 flex justify-center">
                    <button className="text-green-600" onClick={onClose}>OK</button>
                </div>
            </div>
        </Modal>
    )
}

export default AlertError